import { XMarkIcon } from '@heroicons/react/16/solid';
import { useCallback, useEffect, useState, type JSX } from 'react';
import SelectTable from '../data-table/custom-tables/select-table';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
  DialogHeader,
} from '../ui/dialog';
import type { Filter, FilterValue } from './constants';

export default function RelationModal({
  filter,
  initialValue,
  onDone,
  TableFilters,
}: {
  filter: Filter;
  initialValue: FilterValue;
  onDone: (val: string[]) => void;
  TableFilters: ({
    clientState,
    filters,
    tableId,
  }: {
    clientState?: boolean;
    filters: Filter[];
    tableId: string;
  }) => JSX.Element;
}) {
  const [value, setValue] = useState<string[] | null>(null);

  useEffect(() => {
    if (initialValue && !value && Array.isArray(initialValue)) {
      setValue(initialValue);
    }
  }, [initialValue, value]);

  const updateValue = useCallback(
    (selected: string) => {
      if ((value ?? []).includes(selected)) {
        setValue((value ?? []).filter((v) => v != selected));
      } else {
        setValue([...(value ?? []), selected]);
      }
    },
    [value]
  );

  const handleDone = useCallback(
    (val: string[] | null) => onDone(val ?? []),
    [onDone]
  );

  if (!filter.relationModelName) return;
  return (
    <Dialog key='0' defaultOpen onOpenChange={() => handleDone(value)}>
      <DialogContent className='min-w-[600px] gap-0 p-0'>
        <DialogHeader>
          <DialogTitle>Välj filtrering</DialogTitle>
          <Button
            onClick={() => handleDone(value)}
            variant='secondary'
            size='icon-sm'
          >
            <XMarkIcon className='size-4' />
          </Button>
          <DialogDescription className='sr-only'>
            Filtrera på {filter.title}
          </DialogDescription>
        </DialogHeader>
        <div className='max-h-[min(800px,calc(var(--window-keeper-height)-175px))] min-h-[500px] min-w-[600px] overflow-y-auto'>
          <SelectTable
            tableId={`${filter.relationModelName}`}
            onSelected={updateValue}
            TableFilters={TableFilters}
            maxSelectedItems={filter.maxSelectedItems}
            isMultiSelect
            queryParams={
              filter.relationDefaultFilters
                ? { filters: filter.relationDefaultFilters }
                : undefined
            }
            selected={value ?? []}
            modelName={filter.relationModelName}
          />
        </div>
        <DialogFooter>
          <Button onClick={() => handleDone(value)}>Klar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
